package com.trevorwiebe.timesheet.signin.presentation.auth

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.unit.dp
import com.trevorwiebe.timesheet.core.presentation.common.TimeSheetButton
import com.trevorwiebe.timesheet.core.presentation.common.TimesheetTextField
import kotlinx.coroutines.launch

@Composable
actual fun SignInBlock(
    modifier: Modifier,
    onEmailChanged: (String) -> Unit,
    onSignIn: (String, String) -> Unit,
) {
    val focusRequester1 = remember { FocusRequester() }
    val focusRequester2 = remember { FocusRequester() }
    val coroutineScope = rememberCoroutineScope()

    var email by remember { mutableStateOf("") }
    var password by remember { mutableStateOf("") }

    Column(modifier = modifier) {
        TimesheetTextField(
            modifier = Modifier.focusRequester(focusRequester1),
            text = email,
            placeholder = "Email",
            singleLine = true,
            onTextChange = {
                email = it
                onEmailChanged(it)
            },
            keyboardOptions = KeyboardOptions(
                imeAction = ImeAction.Next,
                keyboardType = KeyboardType.Email,
                capitalization = KeyboardCapitalization.None
            ),
            keyboardActions = KeyboardActions(
                onNext = {
                    coroutineScope.launch { focusRequester2.requestFocus() }
                }
            )
        )

        Spacer(modifier = Modifier.height(24.dp))

        TimesheetTextField(
            modifier = Modifier.focusRequester(focusRequester2),
            text = password,
            placeholder = "Password",
            singleLine = true,
            keyboardOptions = KeyboardOptions.Default.copy(
                imeAction = ImeAction.Done,
                keyboardType = KeyboardType.Password
            ),
            hidePasswordText = true,
            onTextChange = { password = it },
            keyboardActions = KeyboardActions(
                onDone = { onSignIn(email, password) }
            )
        )

        Spacer(modifier = Modifier.height(24.dp))

        TimeSheetButton(
            modifier = Modifier.fillMaxWidth().height(50.dp),
            text = "Log In",
            onClick = { onSignIn(email, password) },
            loading = false,
            enabled = true
        )
    }
}
